import React from 'react'

export const Disclaimer = ({title, subtitle, type}) =>(

    <section className={`hero ${type} section-wrapper table-wrapper`}>
      <div className="hero-body">
        <div className="">
          <h1 className="title">
            {title}
          </h1>
          <h2 className="subtitle">
            {subtitle}
          </h2>
        </div>
      </div>
    </section>

)
